import React from "react";
import {Link} from "react-router-dom";


export default function About() {

    return (
        <>
            <header>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold tracking-tight text-gray-900 text-center">
                        About
                    </h1>
                </div>
            </header>
            <main>

                <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6 lg:px-8 flex flex-col gap-2">

                    <p>
                        This is a Progressive Web App (PWA) demo application, showing how a website can feel
                        just
                        like an app on a smartphone, without actually building a native app through the app
                        store.
                    </p>

                    <h2 className="mt-2 text-lg font-semibold">How to save this website like an app & use it
                        offline</h2>
                    <ul className="list-disc pl-5 text-gray-700">
                        <li className="mb-2">
                            <strong>On Android:</strong> Open this website in Chrome, tap the menu (three dots) in the
                            top-right corner, and select <em>Add to Home Screen</em>.
                        </li>
                        <li className="mb-2">
                            <strong>On iOS (Safari):</strong> Open this website in Safari, tap the <em>Share</em> icon
                            (square with an arrow), then select <em>Add to Home Screen</em>.
                        </li>
                        <li className="mb-2">
                            <strong>On Desktop (Chrome/Edge):</strong> Open this website, click the install icon in the
                            address bar (a square with a plus sign), and follow the prompts.
                        </li>
                        <li className="mb-2">
                            <strong>On Desktop (Safari):</strong> Open this website, click the File menu, then
                            select <em>Add to Dock</em>.
                        </li>
                    </ul>


                </div>

                <div className="mx-auto max-w-2xl px-4 py-8">
                    <p className="">Built with: React, Workbox, Tailwind CSS & UI.</p>
                    <p className="mt-2 sm:hidden ">Made by <a href="https://mermaiddevs.com" className="underline" target="_blank">Mermaid
                        Devs Pty Ltd</a> - Michelle Retzlaff.</p>
                </div>


            </main>
        </>
    );
}
